"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const react_use_measure_1 = __importDefault(require("react-use-measure"));
const react_window_1 = require("react-window");
const react_window_infinite_loader_1 = __importDefault(require("react-window-infinite-loader"));
const LinearProgress_1 = __importDefault(require("@material-ui/core/LinearProgress"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const MoodBad_1 = __importDefault(require("@material-ui/icons/MoodBad"));
const table_hook_1 = require("./table-hook");
const table_context_1 = require("./table-context");
const compose_refs_1 = require("../../utils/compose-refs");
const use_scrollbar_size_1 = require("../../utils/use-scrollbar-size");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
// eslint-disable-next-line react/display-name
exports.Table = react_1.memo(react_1.forwardRef(function Table(options, ref) {
    const { props, context, selectedContext, columnDialogRef, filterDialogRef, exportDialogRef, loaderRef, listRef, searchbarRef, handleKeyNavigation, } = table_hook_1.useTable(options, ref);
    // eslint-disable-next-line react/prop-types
    const { SearchbarComponent, ToolbarComponent, ColumnDialogComponent, FilterDialogComponent, ExportDialogComponent, HeaderComponent, RowComponent, source, height, toolbarProps, createRowStyle, } = props;
    const classes = context.classes;
    const isItemLoaded = react_1.useCallback((index) => {
        return source.isDataValid() && index < source.items.length;
    }, [source]);
    const renderItem = react_1.useCallback((props) => {
        const { index, style } = props;
        return (react_1.default.createElement("div", { style: style }, index < source.items.length ? (react_1.default.createElement(RowComponent, { value: source.items[index], index: index, selected: false, rowStyle: createRowStyle(source.items[index]) })) : (react_1.default.createElement(react_1.default.Fragment, null))));
    }, [source.items, createRowStyle]);
    const [barMeasureRef, { height: barHeight }] = react_use_measure_1.default({
        debounce: 200,
    });
    // we need real width of the header for the react-window wrapper
    const [headerMeasureRef, { width: headerWidth, height: headerHeight },] = react_use_measure_1.default({
        debounce: 200,
    });
    const totalCount = source.hasNextPage()
        ? source.items.length + 1
        : source.items.length;
    const scrollbarHeight = use_scrollbar_size_1.useScrollBarSize();
    const listHeight = height - barHeight - headerHeight - scrollbarHeight;
    function serializeColumns(columns) {
        return columns.map((column) => {
            var _a, _b, _c, _d, _e;
            return ({
                name: column.name,
                datakey: column.datakey,
                displaykey: column.displaykey,
                width: column.width,
                visible: column.visible,
                cellComponentName: (_a = column.CellComponent.displayName) !== null && _a !== void 0 ? _a : column.CellComponent.name,
                valueMapperName: (_c = (_b = column.valueMapper) === null || _b === void 0 ? void 0 : _b.displayName) !== null && _c !== void 0 ? _c : (_d = column.valueMapper) === null || _d === void 0 ? void 0 : _d.name,
                valueMapperData: (_e = column.valueMapper) === null || _e === void 0 ? void 0 : _e.data,
            });
        });
    }
    const provideData = event_callback_hook_1.useEventCallback(() => ({
        ...props.exportProvideData(),
        params: source.getParams(),
        selected: selectedContext.selected,
        columns: serializeColumns(context.filteredColumns),
        title: props.tableName,
    }));
    const filterCount = context.filtersState.filter((filter) => filter.enabled)
        .length;
    /**
     * 1. loading is finished
     * 2. result has 0 items
     * 3. is enabled > 0 filters || is filled searchQuery
     */
    const showNoMatchMessage = !source.loading &&
        source.items.length === 0 &&
        (filterCount !== 0 || !!context.searchQuery);
    const handleClearSettings = event_callback_hook_1.useEventCallback(() => {
        var _a;
        context.setFiltersState(context.filtersState.map((state) => ({
            ...state,
            value: null,
            enabled: false,
            object: null,
            filters: [],
            numberFilter: null,
        })));
        context.directSetSearchQuery('');
        (_a = searchbarRef.current) === null || _a === void 0 ? void 0 : _a.setSearchText('');
    });
    return (react_1.default.createElement(table_context_1.TableContext.Provider, { value: context },
        react_1.default.createElement(table_context_1.TableSelectedContext.Provider, { value: selectedContext },
            react_1.default.createElement("div", { className: classes.wrapper, "data-cy": "EAS__TABLE" },
                react_1.default.createElement("div", { className: classes.tableGroupWrapper },
                    react_1.default.createElement("div", { ref: barMeasureRef },
                        react_1.default.createElement("div", { className: classes.searchWrapper }, props.showSearchbar && (react_1.default.createElement(SearchbarComponent, { ref: searchbarRef }))),
                        react_1.default.createElement(ToolbarComponent, Object.assign({}, toolbarProps))),
                    react_1.default.createElement("div", { className: classes.tableWrapper, tabIndex: 0, onKeyDown: handleKeyNavigation },
                        source.loading && (react_1.default.createElement(LinearProgress_1.default, { classes: { root: classes.progress } })),
                        react_1.default.createElement(HeaderComponent, { ref: headerMeasureRef }),
                        showNoMatchMessage && (react_1.default.createElement("div", { className: classes.noMatch },
                            react_1.default.createElement(MoodBad_1.default, { fontSize: "large" }),
                            react_1.default.createElement(Typography_1.default, null,
                                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_EMPTY_SOURCE", defaultMessage: "Zadan\u00FDm filtr\u016Fm neodpov\u00EDdaj\u00ED \u017E\u00E1dn\u00E9 z\u00E1znamy." })),
                            react_1.default.createElement(Typography_1.default, { component: "a", onClick: handleClearSettings },
                                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_EMPTY_SOURCE_REFRESH", defaultMessage: "Obnovit v\u00FDchoz\u00ED nastaven\u00ED filtr\u016F" })))),
                        react_1.default.createElement("div", { className: classes.dataWrapper, style: { width: headerWidth } },
                            react_1.default.createElement(react_window_infinite_loader_1.default, { ref: loaderRef, isItemLoaded: isItemLoaded, itemCount: totalCount, loadMoreItems: source.loadMore }, ({ onItemsRendered, ref }) => {
                                const composedRef = compose_refs_1.composeRefs(ref, listRef);
                                return (react_1.default.createElement(react_window_1.FixedSizeList, { height: listHeight, width: "100%", itemSize: 30, itemCount: totalCount, ref: composedRef, onItemsRendered: onItemsRendered, className: classes.scrollContainer, direction: "rtl" }, renderItem));
                            })))),
                react_1.default.createElement(ColumnDialogComponent, { ref: columnDialogRef }),
                react_1.default.createElement(FilterDialogComponent, { ref: filterDialogRef }),
                props.reportTag !== null && (react_1.default.createElement(ExportDialogComponent, { ref: exportDialogRef, tag: props.reportTag, provideData: provideData }))))));
}));
//# sourceMappingURL=table.js.map